import { Action } from 'redux';
import * as Actions from './actionTypes';
import { buildErrorAction, ErrorAction } from 'src/common/apiLoader/state/actions';
import { ExpenditureRecord, ExpenditureRecordsFilters } from 'src/common/models/expenditureRecord';
import { PayableContractDebit, PayableContractDebitRecordsFilters } from 'src/common/models/payableContractDebit';
import { PayableContractPayment, PayableContractPaymentRecordsFilters } from 'src/common/models/payableContractDebitPayment';
import { SuccessResponse } from 'src/common/models/common';

export interface GetExpenditureRecordsAction extends Action {
    filters?: ExpenditureRecordsFilters
}
export interface GetExpenditureRecordsSuccessAction extends Action {
    expenditureRecords: ExpenditureRecord[]
}
export const getExpenditureRecordsApi = (filters?: ExpenditureRecordsFilters): GetExpenditureRecordsAction => ({
    type: Actions.GET_EXPENDITURE_RECORDS_API,
    filters,
})
export const getExpenditureRecordsApiSuccess = (expenditureRecords: ExpenditureRecord[]): GetExpenditureRecordsSuccessAction => ({
    type: Actions.GET_EXPENDITURE_RECORDS_API_SUCCESS,
    expenditureRecords,
})
export const getExpenditureRecordsApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_EXPENDITURE_RECORDS_API_ERROR,
    error,
)

export interface CreateExpenditureRecordAction extends Action {
    expenditureRecord: ExpenditureRecord
}
export interface CreateExpenditureRecordSuccessAction extends Action {
    expenditureRecord: ExpenditureRecord
}
export const createExpenditureRecordApi = (expenditureRecord: ExpenditureRecord): CreateExpenditureRecordAction => ({
    type: Actions.CREATE_EXPENDITURE_RECORD_API,
    expenditureRecord,
})
export const createExpenditureRecordApiSuccess = (expenditureRecord: ExpenditureRecord): CreateExpenditureRecordSuccessAction => ({
    type: Actions.CREATE_EXPENDITURE_RECORD_API_SUCCESS,
    expenditureRecord,
})
export const createExpenditureRecordApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.CREATE_EXPENDITURE_RECORD_API_ERROR,
    error,
)

export interface GetPayableContractDebitsAction extends Action {
    filters?: PayableContractDebitRecordsFilters
}
export interface GetPayableContractDebitsSuccessAction extends Action {
    payableContractDebits: PayableContractDebit[]
}
export const getPayableContractDebitsApi = (filters?: PayableContractDebitRecordsFilters): GetPayableContractDebitsAction => ({
    type: Actions.GET_PAYABLE_CONTRACT_DEBITS_API,
    filters,
})
export const getPayableContractDebitsApiSuccess = (payableContractDebits: PayableContractDebit[]): GetPayableContractDebitsSuccessAction => ({
    type: Actions.GET_PAYABLE_CONTRACT_DEBITS_API_SUCCESS,
    payableContractDebits,
})
export const getPayableContractDebitsApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_PAYABLE_CONTRACT_DEBITS_API_ERROR,
    error,
)

export interface GetPayableDebitByIdAction extends Action {
    id: number
}
export interface GetPayableDebitByIdSuccessAction extends Action {
    payableDebit: PayableContractDebit
}
export const getPayableDebitByIdApi = (id: number): GetPayableDebitByIdAction => ({
    type: Actions.GET_PAYABLE_DEBIT_BY_ID_API,
    id,
})
export const getPayableDebitByIdApiSuccess = (payableDebit: PayableContractDebit): GetPayableDebitByIdSuccessAction => ({
    type: Actions.GET_PAYABLE_DEBIT_BY_ID_API_SUCCESS,
    payableDebit,
})
export const getPayableDebitByIdApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_PAYABLE_DEBIT_BY_ID_API_ERROR,
    error,
)

export const cleanCurrentPayableDebit = (): Action => {
    return {
        type: Actions.CLEAN_CURRENT_PAYABLE_DEBIT,
    }
};

export interface CreatePayableDebitPaymentAction extends Action {
    contractPayment: PayableContractPayment
}
export interface CreatePayableDebitPaymentSuccessAction extends Action {
    contractPayment: PayableContractPayment
}
export const createPayablePaymentApi = (contractPayment: PayableContractPayment): CreatePayableDebitPaymentAction => ({
    type: Actions.CREATE_PAYABLE_DEBIT_PAYMENT_API,
    contractPayment,
})
export const createPayablePaymentApiSuccess = (contractPayment: PayableContractPayment): CreatePayableDebitPaymentSuccessAction => ({
    type: Actions.CREATE_PAYABLE_DEBIT_PAYMENT_API_SUCCESS,
    contractPayment,
})
export const createPayablePaymentApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.CREATE_PAYABLE_DEBIT_PAYMENT_API_ERROR,
    error,
)

export interface GetPayableContractPaymentRecordsAction extends Action {
    filters?: PayableContractPaymentRecordsFilters
}
export interface GetPayableContractPaymentRecordsSuccessAction extends Action {
    contractPayments: PayableContractPayment[]
}
export const getPayableContractPaymentRecordsApi = (filters?: PayableContractPaymentRecordsFilters): GetPayableContractPaymentRecordsAction => ({
    type: Actions.GET_PAYABLE_CONTRACT_PAYMENTS_API,
    filters,
})
export const getPayableContractPaymentRecordsApiSuccess = (contractPayments: PayableContractPayment[]): GetPayableContractPaymentRecordsSuccessAction => ({
    type: Actions.GET_PAYABLE_CONTRACT_PAYMENTS_API_SUCCESS,
    contractPayments,
})
export const getPayableContractPaymentRecordsApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_PAYABLE_CONTRACT_PAYMENTS_API_ERROR,
    error,
)

export interface DeletePayableContractDebitAction extends Action {
    id: number
}
export interface DeletePayableContractDebitSuccessAction extends Action {
    response: SuccessResponse
}
export const deletePayableContractDebitApi = (id: number): DeletePayableContractDebitAction => ({
    type: Actions.DELETE_PAYABLE_CONTRACT_DEBIT_API,
    id,
})
export const deletePayableContractDebitApiSuccess = (response: SuccessResponse): DeletePayableContractDebitSuccessAction => ({
    type: Actions.DELETE_PAYABLE_CONTRACT_DEBIT_API_SUCCESS,
    response,
})
export const deletePayableContractDebitApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_PAYABLE_CONTRACT_DEBITS_API_ERROR,
    error,
)